/* ============================================================
   v3 shared runtime — mobile nav menu + one-shot reveals.
   Loaded on every v3 layout (home + marketing pages). The hero
   scrub stays in home.js.
   ============================================================ */
(function () {
  'use strict';

  document.documentElement.classList.add('hm-js');

  /* ── Mobile nav menu ── */
  var burger = document.getElementById('hm-nav-burger');
  var menu = document.getElementById('hm-nav-menu');
  if (burger && menu) {
    var setMenu = function (open) {
      burger.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('hm-menu-open', open);
      if (open) {
        menu.hidden = false;
        void menu.offsetHeight; /* commit display before the fade starts */
        menu.classList.add('is-open');
      } else {
        menu.classList.remove('is-open');
        setTimeout(function () { menu.hidden = true; }, 300);
      }
    };
    burger.addEventListener('click', function () {
      setMenu(burger.getAttribute('aria-expanded') !== 'true');
    });
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) setMenu(false);
    });
  }

  /* ── Reveals: one IntersectionObserver, unobserve after fire ── */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = [].slice.call(document.querySelectorAll('[data-reveal]'));
  if (reduced || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) {
      el.style.opacity = '1'; el.style.transform = 'none';
    });
  } else if (revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var delay = (parseInt(el.getAttribute('data-reveal'), 10) || 0) * 90;
        el.style.transition = 'opacity 0.4s ease-out ' + delay + 'ms, transform 0.4s ease-out ' + delay + 'ms';
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -25% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }
})();

/* ── The bag's count ──────────────────────────────────────────────────────
   Liquid renders the count, so it is right on load with no JS. This exists
   for the two moments Liquid cannot see:

     · an AJAX add — the configurator adds to cart with fetch and never
       reloads, so the bar would otherwise keep showing the old number until
       the next navigation;
     · a bfcache restore — coming BACK to a page after checking out or
       emptying the bag replays the old DOM, count and all. `pageshow` with
       persisted is the only event that fires for it.

   Fails silent and leaves the server-rendered number alone: a wrong count is
   worse than a stale one, and the cart page itself is always authoritative. */
(function () {
  var bag = document.getElementById('hm-nav-bag');
  var out = document.getElementById('hm-nav-bag-count');
  if (!bag || !out) return;

  function paint(n) {
    if (typeof n !== 'number' || !isFinite(n) || n < 0) return;
    bag.setAttribute('data-count', String(n));
    out.textContent = String(n);
    bag.setAttribute('aria-label',
      n > 0 ? 'Bag, ' + n + ' item' + (n === 1 ? '' : 's') : 'Bag, empty');
  }

  function refresh() {
    fetch(window.Shopify && Shopify.routes && Shopify.routes.root
            ? Shopify.routes.root + 'cart.js' : '/cart.js',
          { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) paint(c.item_count); })
      .catch(function () { /* keep whatever Liquid rendered */ });
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  /* Anything that changes the cart can announce it and the bar will follow. */
  document.addEventListener('pp:cart-changed', refresh);
  window.ppRefreshBag = refresh;
})();
